<template>
  <div class="main print-no-padding accountManage">
    <h2 class="is-print-hide title-area">
      <div class="title">
        <span class="main-title">账户管理</span>
      </div>
      <div class="handle-bar">
        <el-button class="btn" @click="handleBatchPay">批量充值</el-button>
      </div>
    </h2>
    <el-card>
      <searchBar :search-params="searchParams" @change="change" @search="search" />
      <accountTable
        :page-no="searchParams.pageNo"
        :page-size="searchParams.pageSize"
        :data="data"
        :total="total"
        @handle-pageNo="handlePageNo"
        @handle-pageSize="handlePageSize"
        @refresh="init"
        @selection-change="handleSelectionChange"
        @pay="handleToPay"
      />
    </el-card>
    <prepayDrawer :visible.sync="drawerVisible" :dataList="dataList" @paySuccess="handlePaySuccess" />
  </div>
</template>

<script>
import Fetch from '@/api';
import searchBar from './components/searchBar';
import accountTable from './components/accountTable';
import prepayDrawer from './components/prepayDrawer';

export default {
  name: 'accountManage',
  components: {
    searchBar,
    accountTable,
    prepayDrawer
  },
  data() {
    return {
      searchParams: {
        merchantName: '',
        pageNo: 1,
        pageSize: 10
      },
      data: [],
      total: 0,
      selections: [],
      drawerVisible: false,
      currentRow: [],
      muilt: false
    };
  },
  computed: {
    dataList() {
      if (this.muilt) {
        return this.selections;
      } else {
        return this.currentRow;
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    change(key, val) {
      this.searchParams[key] = val;
    },
    fetchDrugPage(params) {
      return Fetch.getMerchantAccountList(params).then(({ data, pageNo, pageSize, totalCount }) => {
        this.data = data;
        this.total = totalCount;
        this.searchParams.pageNo = pageNo;
        this.searchParams.pageSize = pageSize;
      });
    },
    init() {
      return this.fetchDrugPage(this.searchParams);
    },
    search() {
      const { merchantName } = this.searchParams;
      return this.fetchDrugPage({ merchantName, pageNo: 1, pageSize: 10 });
    },
    handlePageNo(pageNo) {
      const { merchantName, pageSize } = this.searchParams;
      return this.fetchDrugPage({ merchantName, pageNo, pageSize });
    },
    handlePageSize(pageSize) {
      const { merchantName, pageNo } = this.searchParams;
      return this.fetchDrugPage({ merchantName, pageNo, pageSize });
    },
    handleSelectionChange(rows) {
      this.selections = rows;
    },
    handleBatchPay() {
      // window.open('https://static.91jkys.com/kaer/zhiyunkuaiyao/index.html#/', '_blank');
      if (!Array.isArray(this.selections) || this.selections.length === 0) {
        this.$message.error('请先选择充值门店');
        return;
      }
      this.muilt = true;
      this.drawerVisible = true;
    },
    handleToPay(row) {
      // window.open('https://static.91jkys.com/kaer/zhiyunkuaiyao/index.html#/', '_blank');
      if (row.merchantStatus == 1) {
        this.$message.error('药店被禁用');
        return;
      }
      this.muilt = false;
      this.drawerVisible = true;
      this.currentRow = [row];
    },
    handlePaySuccess() {
      this.init();
    }
  }
};
</script>

<style lang="scss" scoped>
.accountManage {
  .title-area {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    .sub-title {
      margin-left: 8px;
      font-size: 12px;
      color: #bdbdbd;
    }

    .handle-bar {
      .btn {
        width: 132px;
        color: #ebb436;
        border: 1px solid #ebb436;
      }
    }
  }
}
</style>
